import { Fragment } from "react";

import useAccountCreationLogin from "./UseAccountCreationLogin";

import ExternalLoginForm from "../../components/forms/ExternalLoginForm";

import Headings from "@usas/ui-web/components/headings/Headings";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import Constants from "@usas/ui-web/utils/Constants";
import style from '../../../../LandingPages.module.css';

const AccountCreationLogin = () => {
  const {
    isLoading,
    loginErrorPopupState,
    onExternalLoginClicked,
    onCreateALoginClicked,
    onCloseLoginErrorPopupClicked
  } = useAccountCreationLogin();

  return (
    <Fragment>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-sm-2 col-md-3" />
        <div className={['col-xs-12', 'col-sm-8', 'col-md-6', style.CenterPageContent].join(' ')}>
          <Headings.H3>Login</Headings.H3>
          <p>Please log in using our secure external authentication provider.</p>
          <ExternalLoginForm
            onExternalLoginClicked={onExternalLoginClicked}
            onCreateALoginClicked={onCreateALoginClicked} />
        </div>
        <div className="col-xs-12 col-sm-2 col-md-3" />
      </div>
      <PopUpModal
        widthPct={60}
        maxWidth={720}
        title={'Login Error'}
        displayPopUp={loginErrorPopupState.displayPopup === true}>
        <div className="row">
          <div className="col-xs-12">
            <p>{loginErrorPopupState.errorMessage || 'An error occurred.'}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <SecondaryButton type={'button'} onClick={onCloseLoginErrorPopupClicked}>Close</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default AccountCreationLogin;